import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Playlist, Song } from '~/@types/tsl-types';
import { searchApi } from '~/services/api/search.service';

interface SearchState {
  searchValue: string;
  songsFound: Song[];
  playlistFound: Playlist[];
  artistsFound: string[];
  resultCount: number;
}

const initialState = {
  searchValue: '',
  songsFound: [],
  artistsFound: [],
  playlistFound: [],
  resultCount: 0,
} as SearchState;

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(searchApi.endpoints.searchSongs.matchFulfilled, (state, { payload }) => {
      state.songsFound = payload;
      state.resultCount = payload.length;

      const artists = payload.map((song) => song.artist.name);
      state.artistsFound = [...new Set(artists)];
    });
    builder.addMatcher(searchApi.endpoints.searchPlaylists.matchFulfilled, (state, { payload }) => {
      state.playlistFound = payload;
    });
  },
});
